import RevertDefault from '../../blocks/revert-default/revert-default';
import SslSupportService from '../../blocks/ssl-support-service/ssl-support-service';
import find from 'mout/array/find';

export default class BaseSettingsController {
  /*@ngInject*/
  constructor($location, $scope, $q, installerResource, wizardInfo, fields,
    i18n, baseUrlValidator, baseUrlHelper, baseStepUrl, oldUpgradeManager) {
    this.$scope = $scope;
    this.$q = $q;
    this.fields = fields;
    this.i18n = i18n;
    this.installerResource = installerResource;
    this.wizardInfo = wizardInfo;
    this.$location = $location;
    this.baseUrlValidator = baseUrlValidator;
    this.welcomePageAvailable = wizardInfo.isUpgradeAvailable;
    this.checkPathResource = installerResource.checkInstallPath;
    this.baseStepUrl = baseStepUrl;
    this.oldUpgradeManager = oldUpgradeManager;

    this.baseUrlHelper = baseUrlHelper;
    this.validationMessages = baseUrlHelper.VALIDATION_MESSAGES;

    this.errors = null;
    this.revertDefault = null;
    this.isLoaded = false;
    this.isHubStepFinished = null;
    this.certificateUrl = null;

    this.sslSupportService = new SslSupportService();
    installerResource.steps.query().$promise.then(result => {
      const hubStep = find(result, s => s.id === 'hub-settings');
      this.isHubStepFinished = hubStep.completed;
    });

    this.settingsResource = installerResource.getSingletonOf('baseSettings');
    this.defaultSettingsResource = installerResource.baseSettingsDefault.get();

    $q.all([this.settingsResource.$promise, this.defaultSettingsResource.$promise]).then(() => {
      this.revertDefault = new RevertDefault(this.settingsResource, this.defaultSettingsResource);
      this.isLoaded = true;
    }, () => {
      installerResource.clearSingletonOf('baseSettings');
    });
  }

  fixLocaleSettingsInconsistency(res) {
    if (!res[this.fields.LOCALES] || res[this.fields.LOCALES].length === 0) {
      this.settingsResource[this.fields.LOCALE] = 'null';
    }
  }

  nextStep(nextUrl = 'install/hub') {
    if (this.isNextDisabled()) {
      return;
    }
    delete this.errors;
    this.isSaving = true;

    this.baseUrlHelper.verifyBaseUrl(this.settingsResource).
      then(verificationResult => {
        this.settingsResource[this.fields.IS_BUNDLE_ACCESSIBLE] = !verificationResult || verificationResult.isBaseUrlValid !== false;
        this.settingsResource[this.fields.BASE_URL_BACKEND_ACCESS_STATE] = verificationResult ? verificationResult.baseUrlBackendAccessState : null;
        this.settingsResource[this.fields.TEST_ENDPOINT_STATE] = verificationResult ? verificationResult.testEndpointState : null;
      }).
      then(() => this.fixLocaleSettingsInconsistency(this.wizardInfo)).
      then(() => this.settingsResource.$save()).
      then(() => this.$location.url(nextUrl)).
      catch(response => {
        if (response) {
          this.errors = this.installerResource.extractErrorMessage(response.data || response.error || response);

          if (this.errors.sourceLocation && this.errors.sourceLocation.error === 'OLD_UPGRADE_DATA_MUST_BE_REMOVED') {
            this.oldUpgradeManager.manageExistUpgrade(false).
              then(() => this.nextStep(nextUrl));
          }
        }
      }).
      finally(() => {
        this.isSaving = false;
      });
  }

  isNextDisabled() {
    return this.isSaving || this.$scope.settingsForm.$invalid;
  }

  isLicenseStepAvailable() {
    return !this.isNextDisabled() && this.isHubStepFinished;
  }

  getErrorMessage(field) {
    if (this.errors) {
      const error = this.errors[field];
      return error ? error.error_description : error;
    }
    return null;
  }

  clearErrorMessage(field) {
    if (this.errors && this.errors[field]) {
      delete this.errors[field];
    }
  }

  checkPathAccess(path, property) {
    return this.checkPathResource.get({property, path}).$promise;
  }

  onKeyPress($event) {
    if ($event.which === 13) {
      if (!this.isNextDisabled()) {
        this.nextStep();
      }
    }
  }

  revertToDefault() {
    this.certificateUrl = null;
    this.revertDefault.revertToDefault();
  }
}



// WEBPACK FOOTER //
// ./src/pages/base-settings/base-settings__controller.js